export var StackName;
(function (StackName) {
    StackName["oneCell"] = "omnihome_1cell_v1.0";
    StackName["twoCellsWithLeg"] = "omnihome_2cells_v1.0";
    StackName["twoCells"] = "omnihome_2cells_v2.0";
})(StackName || (StackName = {}));
